var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.props.results
    ? _c(
        "div",
        { staticClass: "ia-result" },
        [
          _c("div", { staticClass: "results-section" }, [
            _c(
              "div",
              {
                staticClass: "results-header",
                on: { click: _setup.toggleResults },
              },
              [
                _c("h3", { staticClass: "results-title" }, [
                  _vm._v(_vm._s(_setup.TEXT.response)),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "collapse-button",
                    class: { collapsed: !_setup.isResultsExpanded },
                  },
                  [
                    _c("img", {
                      staticClass: "chevron-icon",
                      attrs: { src: _setup.ICON, alt: "Toggle" },
                    }),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _setup.isResultsExpanded,
                    expression: "isResultsExpanded",
                  },
                ],
                staticClass: "results-content",
              },
              [
                _c("div", {
                  ref: "markdownContentRef",
                  staticClass: "markdown-content",
                  domProps: { innerHTML: _vm._s(_setup.renderedContent) },
                }),
              ]
            ),
          ]),
          _c(_setup.SearchIARelatedDocumentsComponent, {
            attrs: { results: _setup.props.results },
          }),
          _c(_setup.SearchIAToolbarComponent, {
            attrs: {
              content: _setup.plainTextContentWithoutChunks,
              "html-content": _setup.htmlContentWithoutChunks,
              filename: "resultado_busqueda",
              "email-subject": "Resultado de búsqueda avanzada",
            },
          }),
          _c("div", { staticClass: "legal-notice" }, [
            _c("img", {
              staticClass: "info-icon",
              attrs: { src: _setup.infoIcon, alt: "Info" },
            }),
            _c("span", { staticClass: "legal-text" }, [
              _vm._v(_vm._s(_setup.TEXT.legal)),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }